import styled, { css, keyframes } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const CONTACT_TYPE_ICON_SPACE = "19px";
const COPY_ICON_SPACE = "30px";

const ButtonLoadingAnimation = keyframes`
    0% {
        width: 0;
    }
    100% {
        width: 100%;
    }
`;

export const StyledContactItemText = styled(Text)<{ isBlured?: boolean }>`
    ${mixins.truncateText()}
    max-width: calc(100% - ${CONTACT_TYPE_ICON_SPACE});

    filter: ${({ isBlured }) => (isBlured ? "blur(4px)" : "unset")};
`;

export const StyledContactDetailWrapperFlex = styled(Flex)`
    width: calc(100% - ${COPY_ICON_SPACE});

    ${SWReactIcons} {
        padding-bottom: 2px;
    }
`;

export const StyledContactCopyIconButton = styled(IconButton)`
    margin: -2px 0;

    ${SWReactIcons} {
        svg path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;

export const StyledShowMoreButton = styled.button<{ isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    background: none;
    border: none;
    width: fit-content;
    color: ${colorsPalettes.carbon[300]};

    ${SWReactIcons} {
        transform: ${({ isCollapsed }) => (isCollapsed ? "unset" : "rotate(180deg)")};

        svg path {
            fill: ${colorsPalettes.carbon[200]};
        }
    }

    &:hover {
        color: ${colorsPalettes.carbon[500]};

        ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.carbon[400]};
            }
        }
    }
`;

export const StyledRevealIconButtonLabel = styled(Text)`
    margin-left: 4px;
`;

export const StyledContactDetailsOverlayFlex = styled(Flex)`
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const StyledRevealButton = styled(Button)<{ isDisabled?: boolean; isLoading?: boolean }>`
    ${({ isLoading, isDisabled }) =>
        isLoading &&
        isDisabled &&
        css`
            position: relative;
            overflow: hidden;

            &:before {
                content: "";
                position: absolute;
                height: 100%;
                width: 0;
                top: 0;
                left: 0;
                background: ${rgba(colorsPalettes.midnight["500"], 0.25)};
                animation: ${ButtonLoadingAnimation} 2s infinite cubic-bezier(0.4, 0, 0.23, 1);
                z-index: 1;
            }
        `};

    &:hover {
        ${StyledRevealIconButtonLabel} {
            color: ${colorsPalettes.indigo[400]};
        }
    }
`;
